var Calendar = (function($) {
  return {
    container: $('#calendar'),
    event_container: $('#events'),
    date: new Date(),
    isMobile: (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) { return true; } else { return false; }})(navigator.userAgent||navigator.vendor||window.opera),
    isTablet : navigator.userAgent.match(/Tablet|iPad/i),
    filter: [],
    $xhrPool: [],
    init: function() {
      this.setFilter();

      Calendar.createCalendar((Calendar.date.getMonth()+1), Calendar.date.getFullYear());
      $(window).resize(function() {
        Calendar.createCalendar((Calendar.date.getMonth()+1), Calendar.date.getFullYear());
      });
    },
    setTooltips: function() {
      $('[data-tooltip]').each(function() {
          $(this).hover(function() {
              var e=$(this);
              month = $(this).data('month');
              year = $(this).data('year');
              date = $(this).data('date');
              Calendar.hideTooltips();
              jQuery.ajax({
                url: ajax.url,
                data: {
                    action: 'calendar_event_list',
                    month: month,
                    year: year,
                    date: date,
                    filter: Calendar.filter.join(',')
                },
                type: 'GET',
                beforeSend: function(jqXHR) {
                  Calendar.$xhrPool.push(jqXHR);

                },
                complete: function(jqXHR) {
                  var index = Calendar.$xhrPool.indexOf(jqXHR);
                  if (index > -1) {
                      Calendar.$xhrPool.splice(index, 1);
                  }
                },
                success : function( response ) {
                  e.popover({content: response, html: true}).popover('show');
                }
              });
          },function() {
            var e=$(this);
            e.popover('hide');
          });
      });
    },
    hideTooltips: function() {
      $(Calendar.$xhrPool).each(function(idx, jqXHR) {
        jqXHR.abort();
      });
      Calendar.$xhrPool = [];
      $('[data-tooltip]').each(function() {

        $(this).popover('hide');
      });
    },
    setFilter: function() {
      $('.calendar__filter ul li input').each(function() {
        if ($(this).is(':checked')) { Calendar.filter.push($( this ).val()); }

        $(this).change(function() {
          // Check input( $( this ).val() ) for validity here
          if ($(this).is(':checked')) {
            Calendar.filter.push($( this ).val());
          } else {
            Calendar.filter.splice(Calendar.filter.indexOf($( this ).val()), 1);
          }
          Calendar.createCalendar((Calendar.date.getMonth()+1), Calendar.date.getFullYear());
        });
      });
    },
    showLoading: function() {
      $('.spinner').css('display', 'block');
    },
    hideLoading: function() {
      $('.spinner').css('display', 'none');
    },
    setEvents: function() {
      $('button[data-prev]').click(function() {
        date = $(this).attr('data-prev').split('-');
         Calendar.createCalendar(date[1], date[0]);
      });
      $('button[data-next]').click(function() {
        date = $(this).attr('data-next').split('-');
         Calendar.createCalendar(date[1], date[0]);
      });

      $('.has-events').each(function() {
        var that = this;
        $(this).click(function() {
          Calendar.fetchEvent($(that).attr('data-year'), $(that).attr('data-month'), $(that).attr('data-date'));
        });
      });
    },
    createCalendar: function(month, year) {
      Calendar.clearEvents();
      Calendar.hideTooltips();
      Calendar.showLoading();
      var mobile = (this.isMobile || $(window).width() < 768) ? true : '';

      jQuery.ajax({
        url: ajax.url,
        data: {
            action: 'calendar',
            month: month,
            year: year,
            mobile: mobile,
            filter: Calendar.filter.join(',')
        },
        type: 'GET',
        success : function( response ) {
          Calendar.container.html(response);
          Calendar.hideLoading();
          Calendar.hideTooltips();
          Calendar.removeEventOverlay();
          Calendar.setEvents();
          if (!Calendar.isMobile && !Calendar.isTablet)
            Calendar.setTooltips();
          if (mobile)
            Calendar.mobileEvents();
        }
      });
    },
    mobileEvents:function() {
        $('.events__wrap').slick({
          byRow: true,
          dots: true,
          arrows:true,
          infinite: true,
          autoplay: true,
          speed: 1200,
          lazyLoad: 'ondemand',
          prevArrow: '<span class="arrow--left"><span class="icon-prev" aria-hidden="true"><svg role="img" xml:space="preserve"><title>Previous</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/cartmelpriory/dist/images/sprite.svg#arrow_left"></use></svg></span><span class="sr-only">Previous</span></span>',
          nextArrow: '<span class="arrow--right"><span class="icon-next" aria-hidden="true"><svg role="img" xml:space="preserve"><title>Next</title><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/wp-content/themes/cartmelpriory/dist/images/sprite.svg#arrow_right"></use></svg></span><span class="sr-only">Next</span></span>',
          responsive: [{
            breakpoint: 800,
            settings: {
              arrows:true,
              dots: true
            }
          }]
        });
    },
    setEventOverlay: function() {
      var top = $('#calendar table td').offset().top - $('#calendar').offset().top;
      Calendar.event_container.css({ 'top': top, 'height': $('#calendar').height() - top, 'opacity':1, 'zIndex':1061});
      $('.events__close').click(function(e) {
        Calendar.removeEventOverlay();
        e.preventDefault();
      });
    },
    removeEventOverlay: function() {
      Calendar.event_container.css({'opacity':0}).delay(400).queue(function (next) {
        $(this).css({'zIndex':-2});
        next();
      });
      Calendar.clearEvents();
    },
    fetchEvent: function(year, month, date) {

      jQuery.ajax({
        url: ajax.url,
        data: {
            action: 'calendar_event',
            month: month,
            year: year,
            date: date,
            filter: Calendar.filter.join(',')
        },
        type: 'GET',
        success : function( response ) {
          Calendar.event_container.html(response);

          Calendar.setEventOverlay();
        }
      });
    },
    clearEvents: function() {
      Calendar.event_container.html('');
    }
  };

})(jQuery);
